import { Component, OnInit } from '@angular/core';
import { Entry } from 'contentful';
import { APIReferenceV17dot2Page } from 'src/app/model/page/group/api-docs/api-reference-v17dot2-page';
import { ContentfulService } from 'src/app/service/contentful.service';
import { SharedDataService } from 'src/app/service/shared-data.service';
import { ModelValidator } from 'src/app/validator/model-validator';
import htmlTitle from 'src/assets/json/redirects/html-title.json';

@Component({
  selector: 'app-api-reference-v17dot2-page',
  templateUrl: './api-reference-v17dot2-page.component.html',
  styleUrls: ['./api-reference-v17dot2-page.component.scss']
})
export class APIReferenceV17dot2PageComponent implements OnInit {
  apiReferenceV17dot2Page: APIReferenceV17dot2Page = {} as APIReferenceV17dot2Page;

  constructor(private contentfulService: ContentfulService, private sharedDataService: SharedDataService) {}

  ngOnInit(): void {
    htmlTitle.filter((title) => {
      if (title.page === 'api-refernce') {
        this.apiReferenceV17dot2Page.htmlTitle = title.htmlTitle;
      }
    });
    this.apiReferenceV17dot2Page.sections = [];
    this.apiReferenceV17dot2Page.tableSections = [];
    this.apiReferenceV17dot2Page.offerManagementCards = [];
    this.apiReferenceV17dot2Page.orderManagementCards = [];

    const query = { 'fields.title': 'API Reference 17.2' };
    this.contentfulService.getPageContentResponse(query).then((apiReferenceV17dot2PageEntries) => {
      this.mapBanner(apiReferenceV17dot2PageEntries.includes.Entry);
      this.sharedDataService.addSharedData(this.apiReferenceV17dot2Page.banner);
      this.mapSections(apiReferenceV17dot2PageEntries.includes.Entry);
      this.mapTableSection(apiReferenceV17dot2PageEntries.includes.Entry);
      this.mapCards(apiReferenceV17dot2PageEntries.includes.Entry);
      this.mapPageInfo(apiReferenceV17dot2PageEntries.items);
    });
  }

  private mapBanner(apiReferenceV17dot2PageEntries: Entry<any>[]) {
    apiReferenceV17dot2PageEntries
      .filter((entry) => ModelValidator.isBanner(entry))
      .forEach((entry) => {
        this.mapEntryToBanner(entry);
      });
  }

  private mapEntryToBanner(entry: Entry<any>) {

    let imageDetails: any = entry.fields['image'];
    let videoDetails: any = entry.fields['video'];

    this.apiReferenceV17dot2Page.banner =  {
      title: entry.fields['title'] as string,
      subTitle: entry.fields['subTitle'] as string,
      image: imageDetails.fields.file.url,
      video: videoDetails?.fields?.file?.url
    };
  }

  private mapPageInfo(items: Entry<any>[]) {
    items.forEach((entry: any) => {
      let editorDetails = entry.fields?.editorDetails?.split('#');
      this.apiReferenceV17dot2Page.banner.lastUpdated = entry.fields?.lastUpdated;
      this.apiReferenceV17dot2Page.banner.url = entry.fields?.url;
      this.apiReferenceV17dot2Page.banner.editorEmail = editorDetails?.pop();
      this.apiReferenceV17dot2Page.banner.editorShortName = editorDetails?.pop();
      this.apiReferenceV17dot2Page.banner.editorFullName = editorDetails?.pop();
      this.apiReferenceV17dot2Page.htmlTitle = entry.fields.htmlTitle;
    });
  }

  private mapSections(apiReferenceV17dot2PageEntries: Entry<any>[]) {
    apiReferenceV17dot2PageEntries
      .filter((entry) => ModelValidator.isSection(entry))
      .forEach((entry) => {
        this.mapEntryToSection(entry);
      });
    this.apiReferenceV17dot2Page.sections.sort((a, b) => a.order - b.order);
  }

  private mapEntryToSection(entry: Entry<any>) {


    let givenTitle:any=entry.fields['title'] as string;
    let pageTitle=givenTitle.split('#').pop();

    this.apiReferenceV17dot2Page.sections.push({
      title: pageTitle,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number
    });
  }

  private mapTableSection(apiReferenceV17dot2PageEntries: Entry<any>[]) {
    apiReferenceV17dot2PageEntries
      .filter((entry) => ModelValidator.isTableSection(entry))
      .forEach((entry) => {
        this.mapEntryToTableSection(entry);
      });
  }

  private mapEntryToTableSection(entry: Entry<any>) {

    let givenTitle:any=entry.fields['title'] as string;
    let pageTitle=givenTitle.split('#').pop();

    this.apiReferenceV17dot2Page.tableSections.push({
      title: pageTitle,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number,
      table: entry.fields['table'] as string
    });
  }

  private mapCards(apiReferenceV17dot2PageEntries: Entry<any>[]) {
    apiReferenceV17dot2PageEntries
      .filter((entry) => ModelValidator.isCard(entry))
      .forEach((entry) => {
        switch (entry.fields['category']) {
          case 'offer':
            this.mapEntryToOfferManagementCardEntries(entry);
            break;
          case 'order':
            this.mapEntryToOrderManagementCardEntries(entry);
            break;
          default:
          // console.log('new unmapped card category : ' + entry.fields.category);
        }
      });

    this.apiReferenceV17dot2Page.offerManagementCards.sort((a, b) => a.order - b.order);
    this.apiReferenceV17dot2Page.orderManagementCards.sort((a, b) => a.order - b.order);
  }

  private mapEntryToOfferManagementCardEntries(entry: Entry<any>) {

    let givenHeaderImage:any=entry.fields['headImage'];
    this.apiReferenceV17dot2Page.offerManagementCards.push({
      title: entry.fields['title'] as string,
      order: entry.fields['order'] as number,
      titleLink: entry.fields['url'] as string,
      headImage: givenHeaderImage.fields?.file?.url as string,
      buttonText: entry.fields['buttonText'] as string,
      richTextBody: entry.fields['body'] as string
    });
  }
  private mapEntryToOrderManagementCardEntries(entry: Entry<any>) {

    let  givenHeaderImage:any=entry.fields['headImage'];
    this.apiReferenceV17dot2Page.orderManagementCards.push({
      title: entry.fields['title'] as string,
      order: entry.fields['order'] as number,
      titleLink: entry.fields['url'] as string,
      headImage: givenHeaderImage.fields?.file?.url as string,
      buttonText: entry.fields['buttonText'] as string,
      richTextBody: entry.fields['body'] as string
    });
  }
}
